import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { ThemeContextProvider, useTheme } from './contexts/ThemeContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import GlobalStyle from './styles/GlobalStyle';
import { lightTheme, darkTheme } from './styles/theme';

import Home from './pages/Home';
import Settings from './pages/Settings';
import EducationalMaterials from './pages/EducationalMaterials';
import WisdomFiles from './pages/WisdomFilesCopy';
import VideoLibrary from './pages/VideoLibrary';
import Newsletter from './pages/Newsletter';
import NewsEvents from './pages/NewsEvents';

const getBasename = () => {
  if (window.location.pathname.startsWith('/TMW-test')) return '/TMW-test';
  return '/';
};

function AppContent() {
  const { isDarkMode } = useTheme();

  return (
    <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
      <GlobalStyle />
      <Router basename={getBasename()}>
        <div className="App">
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/educational-materials" element={<EducationalMaterials />} />
              <Route path="/wisdom-files" element={<WisdomFiles />} />
              <Route path="/videos" element={<VideoLibrary />} />
              <Route path="/newsletter" element={<Newsletter />} />
              <Route path="/news-events" element={<NewsEvents />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ThemeContextProvider>
      <AppContent />
    </ThemeContextProvider>
  );
}

export default App;
